import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  clearAllFilters: {
    [theme.breakpoints.up("md")]: {
      float: "none",
    },
    minWidth: 91,
    float: "right",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
